import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/models/api-response.model';
import { PortalPromotion } from '@core/models/portal-promotion.model';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { LoadingService } from './loading-service.service';

@Injectable({
  providedIn: 'root'
})
export class PortalTransferHttpService {

  messages$ = new Subject<any[]>();
  isSuccess: boolean;

  constructor(
    private http: HttpClient,
    private loadingService: LoadingService
  ) { }

  transfer(data) {
    this.loadingService.updateBalancesLoadingIndicator('increase');
    return this.http.post<ApiResponse>('/transfer', data).pipe(
      tap(() => this.loadingService.updateBalancesLoadingIndicator('decrease')),
      catchError(err => {
        this.loadingService.updateBalancesLoadingIndicator('decrease');
        return throwError(err);
      })
    );
  }

  transferBy(provider: number, amount: any, direction: number) {
    const data = {
      transfer_from: direction === 1 ? 0 : provider,
      transfer_to: direction === 1 ? provider : 0,
      promotion_id: 0,
      amount: (amount).toString().replace(/[\,]/, ''),
    };

    this.loadingService.updateBalancesLoadingIndicator('increase');
    return this.http.post<ApiResponse>('/transfer', data).pipe(
      tap(() => this.loadingService.updateBalancesLoadingIndicator('decrease')),
      catchError(err => {
        this.loadingService.updateBalancesLoadingIndicator('decrease');
        return throwError(err);
      })
    );
  }

  getProviderBalanceBy(code: string): Observable<number> {
    return this.http.get<ApiResponse>(`/gameprovider/balance?game_provider_code=${code}&check_maintenance=false`).pipe(
      map(res => res.data.rows.balance)
    );
  }

  getPromotions(param: any): Observable<PortalPromotion[]> {
    return this.http.get<ApiResponse>(`/transfer/promotion${param}`).pipe(
      map(res => res.data)
    );
  }

}
